<template>
  <div>
    <Ibox :back="true" titulo="Agregar tipo vehículo">
      <FormGroup cols="6" label="Nombre">
        <input class="form-control" v-model="nombre_tipo_vehiculo" placeholder="Obligatorio">
      </FormGroup>
      <FormGroup cols="12" label="Descripción">
        <textarea class="form-control" rows="4" maxlength="500" v-model="desc_tipo_vehiculo" placeholder="No obligatorio"></textarea>
      </FormGroup>
      <b-col cols="12" align="right" v-if="utils.tienePermiso()">
        <b-button v-if="!is_adding" variant="primary" v-on:click="agregarTipo()">Agregar</b-button>
        <b-button v-else variant="primary">
          <Loading :size="'1'" :text="'Agregando'"/>
        </b-button>
      </b-col>
    </Ibox>
  </div>
</template>

<script>
import {userService} from "@/services";
import {vehiculoService} from "@/services/vehiculo.services";
import {utils} from "@/helpers";

export default {
  name: "Agregar",
  data() {
    return {
      utils,
      tipo_vehiculo: '',
      is_adding: false,
      nombre_tipo_vehiculo: '',
      desc_tipo_vehiculo: '',
    }
  },
  mounted() {
  },
  methods: {
    agregarTipo() {
      if (this.nombre_tipo_vehiculo) {
        var data = {
          'id_cliente': userService.getUser().id_cliente,
          'nombre_tipo': this.nombre_tipo_vehiculo,
          'desc_tipo': this.desc_tipo_vehiculo
        }
        this.is_adding = true;
        vehiculoService.postTipoVehiculo(data).then(respuesta => {
          utils.alerta({'msg': respuesta.msg, 'status': respuesta.status});
          this.is_adding = false;
          if (respuesta.status == 'success') {
            this.$router.go(-1);
          }
        });
      } else {
        utils.alerta({'msg': 'Debe ingresar un nombre para el tipo de vehiculo', 'status': 'warning'});
      }

    }
  }
}
</script>

<style scoped>

</style>